import { getApsClientIdPreview, getApsTier } from "../auth/apsConfig";

/** Actionable help when APS hub discovery returns zero ACC hubs. */
export function AccHubEmptyHelp() {
  const tier = getApsTier();
  const clientPreview = getApsClientIdPreview();

  return (
    <div
      style={{
        margin: 0,
        color: "var(--fc2-text-dim)",
        fontSize: 11,
        lineHeight: 1.45,
      }}
    >
      <p style={{ margin: "0 0 8px" }}>
        No ACC hubs found for this account. Your hubs exist in ACC admin, but
        APS only returns them when the FC2 app is provisioned and you are signed
        in with the matching environment.
      </p>
      <ol style={{ margin: 0, paddingLeft: 18 }}>
        <li>
          In{" "}
          <a
            href="https://acc.autodesk.com/account-admin/custom-integrations"
            target="_blank"
            rel="noreferrer"
            style={{ color: "var(--fc2-accent, #7fb3d5)" }}
          >
            ACC → Hub Admin → Custom integrations
          </a>
          , add <strong>vera-web-pkce-{tier}</strong> with client id starting{" "}
          <code>{clientPreview}</code>. Choose <strong>Full hub access</strong>{" "}
          (or, on older ACC screens, tick both Account Administration and
          Document Management when adding).
        </li>
        <li>
          Confirm <code>VITE_APS_ENV={tier}</code> in repo-root{" "}
          <code>.env</code> matches the app tier you provisioned.
        </li>
        <li>
          Sign out, sign in again, then Refresh — stale tokens from another tier
          can return an empty hub list.
        </li>
        <li>
          You must be a member of at least one active project with Docs / Files
          access in that hub.
        </li>
      </ol>
    </div>
  );
}
